import { render, staticRenderFns } from "./CurrencyUsd.vue?vue&type=template&id=5c94a739&"
import script from "./CurrencyUsd.vue?vue&type=script&lang=js&"
export * from "./CurrencyUsd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports